
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 flex items-center justify-center">
        <div className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-9xl font-bold text-gray-200 dark:text-gray-800">404</h1>
          <h2 className="text-3xl md:text-4xl font-bold mt-8 mb-4">Page Not Found</h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 max-w-lg mx-auto">
            The page you are looking for might have been removed, had its name changed, 
            or is temporarily unavailable.
          </p>
          <Button asChild className="seafarer-btn-primary">
            <Link to="/">
              <Home className="mr-2 h-5 w-5" /> Return to Homepage
            </Link>
          </Button>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
